import React from 'react';
import PaymentResultPage from './PaymentResultPage';

export default function CheckoutSuccessPage() {
  return <PaymentResultPage status="SUCCESS" />;
}
